import classNames from 'classnames';
import React from 'react';

import styles from './styles.module.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  rounded,
  style,
}) => {
  const skeletonStyles: React.CSSProperties = {
    width: width || '100%',
    height: height || '1em',
    ...style,
  };

  const roundedClass = classNames({
    [styles.roundedSm]: rounded === 'sm',
    [styles.roundedMd]: rounded === 'md',
    [styles.roundedLg]: rounded === 'lg',
    [styles.roundedXl]: rounded === 'xl',
    [styles.roundedFull]: rounded === 'full',
  });

  return (
    <div
      className={`${styles.skeleton} ${roundedClass}`}
      style={skeletonStyles}
    ></div>
  );
};

export default Skeleton;
